(() => {
  'use strict';

  const buttons = document.querySelectorAll('[data-srd-digital-pack-add]');
  buttons.forEach((button) => {
    const feedback = document.getElementById(button.getAttribute('aria-describedby'));
    const productHandle = button.dataset.srdDigitalProductHandle || '';
    const variantId = button.dataset.srdDigitalVariantId || '';
    const expectedSku = button.dataset.srdDigitalVariantSku || '';
    const expectedDesign = button.dataset.srdDigitalDesignId || '';

    const fail = (message) => {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      if (feedback) feedback.textContent = message;
    };

    if (!/^[a-z0-9]+(?:-[a-z0-9]+)*-digital-download$/.test(productHandle) || !/^\d+$/.test(variantId) || !/^SRD-DIG-[A-Z0-9-]+-V001$/.test(expectedSku) || !/^SRD-(?:DC|RACE-DC)-[A-Z0-9-]+$/.test(expectedDesign)) {
      fail('This digital file pack is temporarily unavailable. Please contact SRD support.');
      return;
    }

    const addToCart = async () => {
      if (button.disabled) return;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (feedback) feedback.textContent = 'Adding the digital file pack to your cart…';

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok || !Array.isArray(result.items) || result.items.length !== 1 || String(result.items[0].id) !== variantId || result.items[0].sku !== expectedSku) {
          throw new Error('CART_IDENTITY_MISMATCH');
        }
        if (feedback) feedback.textContent = 'Digital file pack added. Opening your cart…';
        window.location.assign(`${root}cart`);
      } catch (_error) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (feedback) feedback.textContent = 'We could not add this digital file pack. Your cart was not changed. Please try again or contact SRD support.';
      }
    };

    const verify = async () => {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}products/${encodeURIComponent(productHandle)}.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        const product = await response.json().catch(() => ({}));
        const variants = Array.isArray(product.variants) ? product.variants : [];
        const variant = variants[0];
        if (!response.ok || product.handle !== productHandle || variants.length !== 1 || String(variant?.id) !== variantId || variant?.sku !== expectedSku || variant?.price !== 1889 || variant?.available !== true) {
          throw new Error('PRODUCT_IDENTITY_MISMATCH');
        }
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        button.textContent = 'Add Digital File Pack — $18.89';
        if (feedback) feedback.textContent = 'Adds one complete digital file pack for this artwork directly to your cart. The physical decal is not included.';
        button.addEventListener('click', addToCart);
      } catch (_error) {
        fail('This digital file pack is temporarily unavailable because its trusted product, variant, SKU, availability, or $18.89 price could not be verified.');
      }
    };

    verify();
  });
})();
